import React from 'react';

export default function UGCFooter() {
  return (
    <footer className="bg-[#060609] border-t border-white/5 py-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-violet-500 to-purple-700 flex items-center justify-center">
            <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
              <path d="M7 1L13 4V10L7 13L1 10V4L7 1Z" fill="white" fillOpacity="0.9" />
            </svg>
          </div>
          <span className="font-sans font-semibold text-white/50 text-sm">
            AI UGC Studio<span className="text-violet-400/60 text-[9px] align-super ml-0.5">™</span>
          </span>
        </div>

        {/* Copyright */}
        <span className="font-sans text-xs text-white/20">
          © 2026 AI UGC Studio™. All rights reserved.
        </span>

        {/* Links */}
        <div className="flex items-center gap-6">
          {['Privacy', 'Terms', 'Contact']?.map((item) => (
            <a
              key={item}
              href="#"
              className="font-sans text-xs text-white/25 hover:text-white/50 transition-colors duration-200"
            >
              {item}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
